import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
    getLegacyEmpresas as getLegacyEmpresasApi,
    getLegacyDepartamentos as getLegacyDepartamentosApi,
    getLegacyPatentes as getLegacyPatentesApi,
    getLegacyPersonas as getLegacyPersonasApi,
    getLegacyCitas as getLegacyCitasApi,
    getLegacyRecepcionesVehiculos as getLegacyRecepcionesVehiculosApi,
    createLegacyRecepcionVehiculo as createLegacyRecepcionVehiculoApi,
    getLegacyMarcas as getLegacyMarcasApi,
    getLegacyModelos as getLegacyModelosApi,
    getLegacyColores as getLegacyColoresApi,
    getLegacyTiposCombustible as getLegacyTiposCombustibleApi,
    getLegacyTiposTraccion as getLegacyTiposTraccionApi,
    getLegacyTiposTransmision as getLegacyTiposTransmisionApi,
    getLegacyTiposTrabajoOt as getLegacyTiposTrabajoOtApi,
    getLegacyRegiones as getLegacyRegionesApi,
    getLegacyCiudades as getLegacyCiudadesApi,
    getLegacyComunas as getLegacyComunasApi 
 } from "../../helpers/api_helper";

export const getLegacyEmpresas = createAsyncThunk("legacyEmpresas/getLegacyEmpresas", async (params) => {
    try {
        const response = await getLegacyEmpresasApi(params);
        return response;
    } catch (error) {
        return error;
    }
});

export const getLegacyDepartamentos = createAsyncThunk("legacyDepartamentos/getLegacyDepartamentos", async (params) => {
    try {
        const response = await getLegacyDepartamentosApi(params);
        return response;
    } catch (error) {
        return error;
    }
});

export const getLegacyPatentes = createAsyncThunk("legacyPatentes/getLegacyPatentes", async (params) => {
    try {
        const response = await getLegacyPatentesApi(params);
        return response;
    } catch (error) {
        return error;
    }
});

export const getLegacyPersonas = createAsyncThunk("legacyPersonas/getLegacyPersonas", async (params) => {
    try {
        const response = await getLegacyPersonasApi(params);
        return response;
    } catch (error) {
        return error;
    }
});

export const getLegacyCitas = createAsyncThunk("glegacyCitas/getLegacyCitas", async (params) => {
    try {
        const response = await getLegacyCitasApi(params);
        return response;
    } catch (error) {
        return error;
    }
});

export const getLegacyMarcas = createAsyncThunk("legacyMarcas/getLegacyMarcas", async (params) => {
    try {
        const response = await getLegacyMarcasApi(params);
        return response;
    } catch (error) {
        return error;
    }
});

export const getLegacyModelos = createAsyncThunk("legacyModelos/getLegacyModelos", async (params) => {
    try {
        const response = await getLegacyModelosApi(params);
        return response;
    } catch (error) {
        return error;
    }
});

export const getLegacyColores = createAsyncThunk("legacyColores/getLegacyColores", async (params) => {
    try {
        const response = await getLegacyColoresApi(params);
        return response;
    } catch (error) {
        return error;
    }
});

export const getLegacyTiposCombustible = createAsyncThunk("legacyTiposCombustible/getLegacyTiposCombustible", async (params) => {
    try {
        const response = await getLegacyTiposCombustibleApi(params);
        return response;
    } catch (error) {
        return error;
    }
});

export const getLegacyTiposTraccion = createAsyncThunk("legacyTiposTraccion/getLegacyTiposTraccion", async (params) => {
    try {
        const response = await getLegacyTiposTraccionApi(params);
        return response;
    } catch (error) {
        return error;
    }
});

export const getLegacyTiposTransmision = createAsyncThunk("legacyTiposTransmision/getLegacyTiposTransmision", async (params) => {
    try {
        const response = await getLegacyTiposTransmisionApi(params);
        return response;
    } catch (error) {
        return error;
    }
});

export const getLegacyTiposTrabajoOt = createAsyncThunk("legacyTiposTrabajoOt/getLegacyTiposTrabajoOt", async (params) => {
    try {
        const response = await getLegacyTiposTrabajoOtApi(params);
        return response;
    } catch (error) {
        return error;
    }
});

export const getLegacyRegiones = createAsyncThunk("legacyRegiones/getLegacyRegiones", async (params) => {
    try {
        const response = await getLegacyRegionesApi(params);
        return response;
    } catch (error) {
        return error;
    }
});

export const getLegacyCiudades = createAsyncThunk("legacyCiudades/getLegacyCiudades", async (params) => {
    try {
        const response = await getLegacyCiudadesApi(params);
        return response;
    } catch (error) {
        return error;
    }
});

export const getLegacyComunas = createAsyncThunk("legacyComunas/getLegacyComunas", async (params) => {
    try {
        const response = await getLegacyComunasApi(params);
        return response;
    } catch (error) {
        return error;
    }
});

export const getLegacyRecepcionesVehiculos = createAsyncThunk("legacyRecepcionesVehiculos/getLegacyRecepcionesVehiculos", async (params) => {
    try {
        const response = await getLegacyRecepcionesVehiculosApi(params);
        return response;
    } catch (error) {
        return error;
    }
});

export const createLegacyRecepcionVehiculo = createAsyncThunk("legacyPatentes/createLegacyRecepcionVehiculo", async (data) => {
    try {
        const response = await createLegacyRecepcionVehiculoApi(data);
        return response;
    } catch (error) {
        return error;
    }
});